import { z } from 'zod';

export const annotatorFieldSchema = z.object({
  field: z.string().nullable(),
  identifierType: z.string().nullable(),
});

export const annotatorOptionSchema = z.object({
  type: z.string(),
  value: z.string().optional(),
});

export const annotatorSchema = z.object({
  type: z.string(),
  name: z.string(),
  description: z.string(),
  url: z.string(),
  validSboTerms: z.array(z.string()),
  availableSourceInformation: z.array(annotatorFieldSchema),
  availableAnnotationsToProvide: z.array(annotatorFieldSchema),
  availableOptions: z.array(annotatorOptionSchema),
});

export const annotatorTargetSchema = z.object({
  type: z.string(),
  name: z.string(),
});

export const annotatorConfigSourceInfoSchema = z.object({
  field: z.string().nullable(),
  identifierType: z.string().nullable(),
  order: z.number().optional(),
});

export const annotatorConfigSchema = z.object({
  annotator: z.string(),
  order: z.number(),
  targets: z.array(z.string()),
  sourceInformation: z.array(annotatorConfigSourceInfoSchema),
  annotationsToProvide: z.array(annotatorFieldSchema),
  options: z.array(z.object({ type: z.string(), value: z.string().optional() })),
});

export const annotatorPresetSchema = z.object({
  id: z.number(),
  name: z.string(),
  updatedAt: z.string(),
  annotators: z.array(annotatorConfigSchema),
});

export const annotationJobStatusSchema = z.enum([
  'PENDING',
  'RUNNING',
  'DONE',
  'FAILED',
  'INTERRUPTED',
  'INTERRUPTING',
]);

export const annotationJobSchema = z.object({
  id: z.number(),
  jobType: z.string(),
  jobStatus: annotationJobStatusSchema,
  jobStarted: z.string().nullable(),
  jobFinished: z.string().nullable(),
  progress: z.number().nullable(),
  externalObjectType: z.string().nullish(),
  externalObjectId: z.number(),
  priority: z.number().optional(),
});

export const annotatorPresetsPageSchema = z.object({
  content: z.array(annotatorPresetSchema),
  size: z.number().optional(),
  number: z.number().optional(),
  totalElements: z.number().optional(),
  totalPages: z.number().optional(),
});

export const annotationJobsPageSchema = z.object({
  content: z.array(annotationJobSchema),
  totalPages: z.number(),
  totalElements: z.number(),
});
